import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockCheckbox from '../components/GuideMockCheckbox';
import GuideMockContainer from '../components/GuideMockContainer';
import GuideMockSelect from '../components/GuideMockSelect';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideSecurityUser: React.FC = () => {
  return (
    <GuidePageLayout
      title="セキュリティチェックを実施する"
      description="月次セキュリティチェックとPCパッチ確認を実施します。"
      breadcrumbs={[{ label: 'セキュリティチェック', path: '/guide/security/overview' }]}
    >
      <GuideSection title="前提">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', 'ログイン済み（権限不問）'],
            ['ログイン状態', 'ログイン済みであること'],
          ]}
        />
      </GuideSection>

      <GuideSection title="月次セキュリティチェックを実施する（BUC-SC04）">
        <GuideStepList
          steps={[
            { label: 'セキュリティチェック画面を開く' },
            { label: '未実施の月次チェックを選択する' },
            { label: '確認事項を読む' },
            {
              label: '「上記を確認しました」にチェックを入れる',
              content: (
                <GuideMockContainer label="確認チェック">
                  <GuideMockCheckbox label="上記を確認しました" checked />
                </GuideMockContainer>
              ),
            },
            {
              label: '「確認」ボタンを押下して実施を確定する',
              content: (
                <GuideMockContainer label="確認ボタン">
                  <GuideMockButton label="確認" startIcon={<CheckCircleIcon />} />
                </GuideMockContainer>
              ),
            },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox type="warning">
            一度実施すると取り消せません。確認事項をよく読んでから実施してください。
          </GuideInfoBox>
        </Stack>
      </GuideSection>

      <GuideSection title="PCセキュリティパッチ確認を実施する（BUC-SC05）">
        <GuideStepList
          steps={[
            { label: 'セキュリティチェック画面を開く' },
            { label: '未実施のPCチェックを選択する' },
            { label: 'PC情報（資産名・管理番号等）を確認する' },
            {
              label: '結果コードをプルダウンから選択する',
              content: (
                <GuideMockContainer label="結果コード選択">
                  <Grid container spacing={2}>
                    <Grid size={6}>
                      <GuideMockSelect
                        label="結果コード"
                        options={['確認済み', '未使用', '初期化済み', '故障中', '廃棄済み']}
                        required
                      />
                    </Grid>
                  </Grid>
                </GuideMockContainer>
              ),
            },
            {
              label: '「確認」ボタンを押下して実施を確定する',
              content: (
                <GuideMockContainer label="確認ボタン">
                  <GuideMockButton label="確認" startIcon={<CheckCircleIcon />} />
                </GuideMockContainer>
              ),
            },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox>PC資産ごとに1件ずつ実施してください。</GuideInfoBox>
          <GuideInfoBox type="warning">一度実施すると取り消せません。</GuideInfoBox>
        </Stack>
      </GuideSection>

      <GuideSection title="結果コード">
        <GuideTable
          headers={['コード', '説明']}
          rows={[
            ['確認済み', 'セキュリティパッチが適用されていることを確認した'],
            ['未使用', '当該PCを現在使用していない'],
            ['初期化済み', 'PCを初期化した'],
            ['故障中', 'PCが故障しており確認できない'],
            ['廃棄済み', 'PCを廃棄済み'],
          ]}
        />
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideSecurityUser;
